/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Container from "../../../Container/Container";
import Hidden from "@mui/material/Hidden";
import divorcePlannerImage from "../../../../assets/img/landingpage/Legalbird_Divorce_Planner.png";
import divorcePlannerSectionStyle from "./divorcePlannerSectionStyle";
import { Box, Grid } from "@mui/material";
import Typography from "@mui/material/Typography";

export type DivorcePlannerSectionProps = {
  header?: string;
  subheader?: string;
};
export const DivorcePlannerSection = ({
  header = "Ihr persönlicher Scheidungsplaner",
  subheader = "Jederzeit genau die Informationen, die Sie brauchen",
}: DivorcePlannerSectionProps) => {
  return (
    <Container sx={divorcePlannerSectionStyle.container}>
      <Typography variant={"h2"} sx={divorcePlannerSectionStyle.heading} dangerouslySetInnerHTML={{ __html: header }} />
      <Typography variant={"h3"} sx={divorcePlannerSectionStyle.subheading}>
        {subheader}
      </Typography>
      <Grid container alignItems={"center"}>
        <Grid item xs={12} sm={6} sx={divorcePlannerSectionStyle.divorceImageContainer}>
          <Box component={"img"} src={divorcePlannerImage} alt="Scheidungsplaner Vorschau" sx={divorcePlannerSectionStyle.imgPhone} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box sx={divorcePlannerSectionStyle.text}>
            <Hidden smDown>
              <p>Sie wollen wissen, wie es weiter geht und was Sie als Nächstes tun müssen?</p>
              <p>
                Bei Legalbird erhalten Sie einen interaktiven Scheidungsplaner mit allen Details zum Ablauf, Tipps und Checklisten - genau auf Ihre persönliche
                Situation ausgerichtet!
              </p>
            </Hidden>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DivorcePlannerSection;
